
export const BASE_URL =   process.env.REACT_APP_BASE_URL  //"http://localhost:8000/api"
console.log('Base url ' , process.env);
// export const BASE_URL = 'https://catering-api.37nationalgamesgoa.in/api'